<!-- ////////// -->
<!-- END STYLESHEETS -->

<!-- BEGIN HEADER-->
<header id="header">
  <div class="headerbar hv2-headerbar">
    <!-- Brand and toggle get grouped for better mobile display -->
    <div class="headerbar-left hv2-headerbar-left">
      <a href="javascript:void(0);" class="btn btn-icon-toggle btn-default hv2-mobile-menu-toggle" (click)="toggleMobileMenu()">
        <i class="fa fa-bars"></i>
      </a>
      <ul class="header-nav header-nav-options hv2-progress-wrap">
        <li *ngIf="loginMode == 'WEB_ADMIN' && isFranchise == 0">
          <div class="hv2-progress-pill" (click)="getClassConfigStatusList()" data-toggle="modal"
            data-target="#class-config-popup">
            <div class="hv2-progress-ring">
              <svg viewBox="0 0 40 40" class="hv2-progress-ring-svg">
                <circle cx="20" cy="20" r="16" class="hv2-progress-ring-track"></circle>
                <circle cx="20" cy="20" r="16" class="hv2-progress-ring-fill" id="percent-progress"
                  role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></circle>
              </svg>
              <span class="hv2-progress-ring-label">{{classConfigPercentage}}%</span>
            </div>
            <span id="percent-text" class="hv2-progress-text"></span>
          </div>
        </li>
      </ul>
    </div>

    <!-- <app-popup (ok_button_event)="alreadyPaid()" [button_text]="'Already Paid Invoice'" [body_content]="subscriptionDetails?.message" [visible]="subscriptionDetails?.isPaymentDue ? 'block' : 'none'" [title]="subscriptionDetails?.title"></app-popup> -->
    <!-- Class config popup -->
    <div class="modal fade hv3-config-modal" id="class-config-popup" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true" data-backdrop="false">
      <div class="modal-dialog hv3-config-dialog">
        <div class="modal-content hv3-config-content">
          <div class="hv3-config-header">
            <button type="button" class="hv3-config-close-btn" data-dismiss="modal" aria-hidden="true">
              <i class="ph ph-x"></i>
            </button>

            <div class="hv3-config-summary" *ngIf="!isProcessing">
              <div class="hv3-summary-ring">
                <svg viewBox="0 0 40 40" class="hv3-summary-ring-svg">
                  <circle cx="20" cy="20" r="16" class="hv3-summary-ring-track"></circle>
                  <circle cx="20" cy="20" r="16" class="hv3-summary-ring-fill"
                    [style.stroke-dasharray]="100.53"
                    [style.stroke-dashoffset]="100.53 - (100.53 * classConfigOverallPercent / 100)"></circle>
                </svg>
                <span class="hv3-summary-ring-label">{{ classConfigOverallPercent }}%</span>
              </div>
              <div class="hv3-summary-text">
                <div class="hv3-summary-title">Overall configuration</div>
                <div class="hv3-summary-subtitle">{{ classConfigFullyConfiguredCount }} of {{ classConfigList.length }} classes fully configured</div>
              </div>
              <div class="hv3-summary-stat hv3-summary-stat-good">
                <span class="hv3-summary-stat-value">{{ classConfigConfiguredModulesCount }}</span>
                <span class="hv3-summary-stat-label">Configured</span>
              </div>
              <div class="hv3-summary-stat hv3-summary-stat-bad">
                <span class="hv3-summary-stat-value">{{ classConfigPendingModulesCount }}</span>
                <span class="hv3-summary-stat-label">Pending</span>
              </div>
            </div>
          </div>

          <div class="hv3-config-body">
            <div class="hv3-config-skeleton" *ngIf="isProcessing">
              <div class="hv3-skeleton-toolbar">
                <p-skeleton width="240px" height="36px" borderRadius="10px"></p-skeleton>
                <p-skeleton width="180px" height="36px" borderRadius="10px"></p-skeleton>
              </div>
              <div class="hv3-skeleton-table">
                <p-skeleton width="100%" height="38px" borderRadius="8px" styleClass="hv3-skeleton-row-head"></p-skeleton>
                <p-skeleton *ngFor="let row of [1,2,3,4,5,6]" width="100%" height="46px" borderRadius="8px" styleClass="hv3-skeleton-row"></p-skeleton>
              </div>
            </div>

            <ng-container *ngIf="!isProcessing">
              <div class="hv3-config-toolbar">
                <div class="hv3-search-box">
                  <i class="ph ph-magnifying-glass"></i>
                  <input type="text" placeholder="Search class..." [(ngModel)]="classConfigSearchTerm" [ngModelOptions]="{standalone: true}" />
                </div>

                <label class="hv3-incomplete-toggle">
                  <input type="checkbox" [(ngModel)]="classConfigOnlyIncomplete" [ngModelOptions]="{standalone: true}" />
                  Only incomplete
                </label>
              </div>

              <!-- Matrix (table) view -->
              <div class="hv3-matrix-section" (click)="onMatrixSectionClick($event)">
                <p-table
                  [value]="filteredClassConfigList"
                  [paginator]="true"
                  [rows]="classConfigPageSize"
                  [rowsPerPageOptions]="classConfigPageSizeOptions"
                  paginatorDropdownAppendTo="body"
                  [showCurrentPageReport]="true"
                  [showFirstLastIcon]="false"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                  responsiveLayout="scroll"
                  styleClass="hv3-p-table"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th>{{ 'header.class' | translate }}</th>
                      <th>{{ 'header.students' | translate }}</th>
                      <th>{{ 'header.timetable' | translate }}</th>
                      <th>{{ 'header.sectionMappedWithClass' | translate }}</th>
                      <th>{{ 'header.classTeacher' | translate }}</th>
                      <th>{{ 'header.subjectsMapping' | translate }}</th>
                      <th>{{ 'header.subjectsToTeacherMapping' | translate }}</th>
                      <th>{{ 'header.feesConfiguration' | translate }}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-c>
                    <tr>
                      <td>{{c.classNumber}} - {{c.classDivision}}</td>
                      <td>
                        <span class="hv3-matrix-pill" [class.hv3-matrix-pill-yes]="c.classStudentMapped" [class.hv3-matrix-pill-no]="!c.classStudentMapped">
                          <i class="ph ph-bold" [class.ph-check]="c.classStudentMapped" [class.ph-x]="!c.classStudentMapped"></i>
                        </span>
                      </td>
                      <td>
                        <span class="hv3-matrix-pill" [class.hv3-matrix-pill-yes]="c.timetableConfigured" [class.hv3-matrix-pill-no]="!c.timetableConfigured">
                          <i class="ph ph-bold" [class.ph-check]="c.timetableConfigured" [class.ph-x]="!c.timetableConfigured"></i>
                        </span>
                      </td>
                      <td>
                        <span class="hv3-matrix-pill" [class.hv3-matrix-pill-yes]="c.isSectionClassMapped" [class.hv3-matrix-pill-no]="!c.isSectionClassMapped">
                          <i class="ph ph-bold" [class.ph-check]="c.isSectionClassMapped" [class.ph-x]="!c.isSectionClassMapped"></i>
                        </span>
                      </td>
                      <td>
                        <span class="hv3-matrix-pill" [class.hv3-matrix-pill-yes]="c.isClassTeacherAssigned" [class.hv3-matrix-pill-no]="!c.isClassTeacherAssigned">
                          <i class="ph ph-bold" [class.ph-check]="c.isClassTeacherAssigned" [class.ph-x]="!c.isClassTeacherAssigned"></i>
                        </span>
                      </td>
                      <td>
                        <span class="hv3-matrix-pill" [class.hv3-matrix-pill-yes]="c.classSubjectsMapping" [class.hv3-matrix-pill-no]="!c.classSubjectsMapping">
                          <i class="ph ph-bold" [class.ph-check]="c.classSubjectsMapping" [class.ph-x]="!c.classSubjectsMapping"></i>
                        </span>
                      </td>
                      <td>
                        <span class="hv3-matrix-pill" [class.hv3-matrix-pill-yes]="c.teacherAssignedToSubject" [class.hv3-matrix-pill-no]="!c.teacherAssignedToSubject">
                          <i class="ph ph-bold" [class.ph-check]="c.teacherAssignedToSubject" [class.ph-x]="!c.teacherAssignedToSubject"></i>
                        </span>
                      </td>
                      <td>
                        <span class="hv3-matrix-pill" [class.hv3-matrix-pill-yes]="c.isFeeConfigured" [class.hv3-matrix-pill-no]="!c.isFeeConfigured">
                          <i class="ph ph-bold" [class.ph-check]="c.isFeeConfigured" [class.ph-x]="!c.isFeeConfigured"></i>
                        </span>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="8" class="hv3-matrix-empty">No classes match your search/filter.</td>
                    </tr>
                  </ng-template>
                </p-table>

                <div class="hv3-matrix-legend">
                  <span class="hv3-matrix-legend-item"><i class="ph ph-bold ph-check hv3-matrix-legend-yes"></i> Configured</span>
                  <span class="hv3-matrix-legend-item"><i class="ph ph-bold ph-x hv3-matrix-legend-no"></i> Not configured</span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <!-- Class config popup -->

    <!-- ////////////////// -->

    <div id="id-print-floating-button" class="col-md-12" style="text-align: -webkit-right;margin-left: -2%;">
      <!-- <button (click)="print_bulk_id_cards()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 10em -2em;"
        type="button"><i class="fa fa-print" aria-hidden="true"></i></button> -->

        <!-- <button (click)="print_bulk_id_cards()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:0;margin: 10em -2em;"
        type="button"><i class="fa fa-print" aria-hidden="true"></i></button> -->

          <button (click)="clear_selected_students()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:14em;right:2em;z-index:1060;"
        type="button">X</button>

      <button *ngIf="idCardServiceEnables==='true' && isAcademicRunning" (click)="openIdCard()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:10em;right:2em;z-index:1060;"
        type="button"><i class="ri-id-card-line"></i></button>

        <button *ngIf="transferCertificateEnables==='true' " (click)="openPopUpForTcGeneration()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:6em;right:2em;z-index:1060;"
        type="button"><i class="ri-article-line"></i></button>
    </div>

    <!-- FOR STAFF -->

        <div id="id-print-floating-button-staff" class="col-md-12" style="text-align: -webkit-right;margin-left: -2%;">

          <button (click)="clear_selected_staffs()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:14em;right:2em;z-index:1060;"
        type="button">X</button>

      <button *ngIf="staffIdCardServiceEnables==='true'" (click)="openStaffIdCard()" class="btn ink-reaction btn-floating-action btn-primary"
        aria-hidden="true"
        style="background: var(--brand-primary-color);border: none;width: 60px;height: 60px;position:fixed;bottom:10em;right:2em;z-index:1060;"
        type="button"><i class="ri-id-card-line"></i></button>

    </div>



    <div id="multiple-id-cards-trigger" class="hide"></div>
    <div data-toggle="modal" data-target="#student-id-preview-popup" id="student-id-preview-popup-open"></div>
    <div class="modal fade" id="student-id-preview-popup" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" style="width: 30%;">
        <div class="modal-content" style="border: 2px solid #324d77;">
          <span class="btn" id="print-id-form"
            style="color: white;float: right;background: #204979;margin-right: 2px;margin-top: 2px;text-transform: unset;">
            {{ 'header.print' | translate }} </span>
          <div class="parent-div-id-card" style="margin-left: 20%;margin-top: 5%">
            <div id="id-receipt-print-container">
              <div *ngFor="let st of idCardDetails?.studentInfo">
                <div style="page-break-after: always">
                </div>
                <!-- Green card -->
                <div *ngIf="!st.busStopName"
                  style="width: 214.094488px;height: 390.480315px;border-radius: 15px 15px;overflow: hidden;perspective: 1px;margin-left: -8px;margin-top: -7px;font-family: Arial">
                  <table style="text-align: -webkit-center;background: #056721;color: white">
                    <tr>
                      <td *ngIf="getSchoolId != '83'">
                        <img style="border-radius: 100px;height: 40px;width: 40px;padding: 5px;"
                          src="{{st.idCardLogo}}">
                      </td>
                      <td *ngIf="getSchoolId == '83'">
                        <img style="border-radius: 20%;height: 40px;width: 40px;padding: 5px;" src="{{st.idCardLogo}}">
                      </td>
                      <td style="width: 100%;text-align: -webkit-center;">
                        <span *ngIf="getSchoolId != '83'"
                          style="letter-spacing: 2px;margin-right: 17px;font-size: 22px;font-weight: bolder;text-transform: uppercase;font-weight: 900;">{{st.schoolNameInIdCard
                          ? st.schoolNameInIdCard : st.schoolName}}</span>
                        <span *ngIf="getSchoolId == '83'"
                          style="letter-spacing: 1px;margin-right: 17px;font-size: 14px;font-weight: bolder;text-transform: uppercase;font-weight: 900;">{{st.schoolNameInIdCard
                          ? st.schoolNameInIdCard : st.schoolName}}</span>
                      </td>
                    </tr>
                  </table>
                  <div
                    style="height: 3%;text-align: center;background-color: yellow;color: green;font-weight: 600;font-size: 10px;">
                    ({{'Affiliated to '+st.affiliatedTo}})
                  </div>
                  <div style="height: 3%;text-align: -webkit-center;background: #056721;color: white;font-size: 10px;">
                    <span style="font-family: Impact, Regular;/*margin-left: -20%;*/">{{ 'header.studentIdCard' | translate }} &nbsp;
                      ({{formatAcademicYear(idCardDetails?.academicInfo.Year)}})</span><!--<span style="float: right;margin-right: 5%;font-weight: 600;">{{idCardDetails?.academicInfo.Year}}</span>-->
                  </div>
                  <div style="height: 48.5%;width:98%">
                    <div style="margin-left: 70px;">
                      <img
                        style="margin-top: 4px;width: 73px;height: 73px;border-style: solid;border-color: #2c661d;border-width: 2px;margin-top: 2px;border-radius: 10px;"
                        bind-src="st.studentImage">
                    </div>
                    <div
                      style="margin-bottom: 3px;margin-top: 1px;color: deeppink;font-weight: 900;text-align: center;font-size: 11px;text-transform: uppercase;">
                      {{st.studentName}}</div>
                    <div *ngIf="st.houseName"
                      style="margin-bottom: 4px;margin-top: -2px;color: deeppink;font-weight: 700;text-align: center;font-size: 9px;text-transform: uppercase;">
                      {{st.houseName}} {{ 'header.house' | translate }}</div>
                    <div
                      style="color: #841cc1;line-height: 12px;font-family: Arial;font-weight: 900;text-align: -webkit-center;">
                      <table border="0"
                        style="font-size: 8px;margin-top: -6px;line-height: normal;margin-left: 5px; text-align: -webkit-center;">
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.admnno' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.registrationId}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.class' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.className}}</td>
                        </tr>
                        <!-- </tr>
                             <td style="font-weight: bold;color: black">Class</td>
                             <td>&nbsp;</td>
                             <td>-</td>
                             <td>
                               <span style="color: blue;font-weight: bold">{{st.className}}</span>
                               &nbsp;<span style="font-weight: bold;width: 45%;color: black">DOB</span>
                               <span>-</span>
                               <span style="color: blue;font-weight: bold">{{formatDOB(st.dateOfBirth)}}</span>
                             </td>
                           </tr>-->
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.dob' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{formatDOB(st.dateOfBirth)}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.father' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.parentName}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.mobile' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.mobileNumber}}</td>
                        </tr>
                        <!--<tr style="height:2px;">
                            <td style="font-weight: bold;color: black">Boarding Pt.</td>
                            <td>&nbsp;&nbsp;&nbsp;</td>
                            <td>-</td>
                            <td style="color: blue;font-weight: bold">{{st.busStopName}}</td>
                          </tr>-->
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.address' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.address}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div
                    style="color: black;margin-left: 173px;font-size: 8px;display: table-caption;margin-bottom: 2px;margin-top: 15px;">
                    <img bind-src="st.principalSign" style=" width: 25px;height: 15px;">
                    <strong style="color: black;font-weight: 600;font-size: 7px;">{{ 'header.principal' | translate }}</strong>
                  </div>
                  <div
                    style="height: 7%;line-height: 1.2;text-align: -webkit-center;background: #056721;color: white;font-size: 10px;border-radius: 0px 0px 15px 15px;overflow: hidden;perspective: 1px;font-weight: 600;">
                    {{st.schoolAaddress}} <br> {{ 'header.ph' | translate }} {{st.phoneNumberInCard}}
                  </div>
                </div>
                <!-- Yellow card -->
                <div *ngIf="st.busStopName"
                  style="width: 214.094488px;height: 390.480315px;border-radius: 15px 15px;overflow: hidden;perspective: 1px;margin-left: -8px;margin-top: -7px;font-family: Arial">
                  <table style="text-align: -webkit-center;background: #fffc00;color: black">
                    <tr>
                      <td *ngIf="getSchoolId != '83'">
                        <img style="border-radius: 100px;height: 40px;width: 40px;padding: 5px;"
                          src="{{st.idCardLogo}}">
                      </td>
                      <td *ngIf="getSchoolId == '83'">
                        <img style="border-radius: 20%;height: 40px;width: 40px;padding: 5px;" src="{{st.idCardLogo}}">
                      </td>
                      <td style="width: 100%;text-align: -webkit-center;">
                        <span *ngIf="getSchoolId != '83'"
                          style="letter-spacing: 2px;margin-right: 17px;font-size: 22px;font-weight: bolder;text-transform: uppercase;font-weight: 900;">{{st.schoolNameInIdCard
                          ? st.schoolNameInIdCard : st.schoolName}}</span>
                        <span *ngIf="getSchoolId == '83'"
                          style="letter-spacing: 1px;margin-right: 17px;font-size: 14px;font-weight: bolder;text-transform: uppercase;font-weight: 900;">{{st.schoolNameInIdCard
                          ? st.schoolNameInIdCard : st.schoolName}}</span>
                      </td>
                    </tr>
                  </table>
                  <div
                    style="height: 3%;text-align: center;background-color: #056721;color: white;font-weight: 600;font-size: 10px;">
                    ({{'Affiliated to '+st.affiliatedTo}})
                  </div>
                  <div style="height: 3%;text-align: -webkit-center;background: #fffc00;color: black;font-size: 10px;">
                    <span style="font-family: Impact, Regular;/*margin-left: -20%;*/">{{ 'header.studentIdCard' | translate }} &nbsp;
                      ({{formatAcademicYear(idCardDetails?.academicInfo.Year)}})</span><!--<span style="float: right;margin-right: 5%;font-weight: 600;">{{idCardDetails?.academicInfo.Year}}</span>-->
                  </div>
                  <div style="height: 48.5%;width:98%">
                    <div style="margin-left: 70px;">
                      <img
                        style="margin-top: 4px;width: 73px;height: 73px;border-style: solid;border-color: #2c661d;border-width: 2px;margin-top: 2px;border-radius: 10px;"
                        bind-src="st.studentImage">
                    </div>
                    <div
                      style="margin-bottom: 3px;margin-top: 1px;color: deeppink;font-weight: 900;text-align: center;font-size: 11px;text-transform: uppercase;">
                      {{st.studentName}}</div>
                    <div *ngIf="st.houseName"
                      style="margin-bottom: 4px;margin-top: -2px;color: deeppink;font-weight: 700;text-align: center;font-size: 9px;text-transform: uppercase;">
                      {{st.houseName}} {{ 'header.house' | translate }}</div>
                    <div
                      style="color: #841cc1;line-height: 12px;font-family: Arial;font-weight: 900;text-align: -webkit-center;">
                      <table border="0"
                        style="font-size: 8px;margin-top: -6px;line-height: normal;margin-left: 5px; text-align: -webkit-center;">
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.admnno' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.registrationId}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.class' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.className}}</td>
                        </tr>
                        <!-- </tr>
                             <td style="font-weight: bold;color: black">Class</td>
                             <td>&nbsp;</td>
                             <td>-</td>
                             <td>
                               <span style="color: blue;font-weight: bold">{{st.className}}</span>
                               &nbsp;<span style="font-weight: bold;width: 45%;color: black">DOB</span>
                               <span>-</span>
                               <span style="color: blue;font-weight: bold">{{formatDOB(st.dateOfBirth)}}</span>
                             </td>
                           </tr>-->
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.dob' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{formatDOB(st.dateOfBirth)}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.father' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.parentName}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.mobile' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.mobileNumber}}</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.boardingPt' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.busStopName}}&nbsp;({{st.BusName}})</td>
                        </tr>
                        <tr style="height:2px;">
                          <td style="font-weight: bold;color: black">{{ 'header.address' | translate }}</td>
                          <td>&nbsp;&nbsp;&nbsp;</td>
                          <td>-</td>
                          <td style="color: blue;font-weight: bold">{{st.address}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div
                    style="color: black;margin-left: 173px;font-size: 8px;display: table-caption;margin-bottom: 2px;margin-top: 15px;">
                    <img bind-src="st.principalSign" style=" width: 25px;height: 15px;">
                    <strong style="color: black;font-weight: 600;font-size: 7px;">{{ 'header.principal' | translate }}</strong>
                  </div>
                  <div
                    style="height: 7%;line-height: 1.2;text-align: -webkit-center;background: #fffc00;color: black;font-size: 10px;border-radius: 0px 0px 15px 15px;overflow: hidden;perspective: 1px;font-weight: 600;">
                    {{st.schoolAaddress}} <br> {{ 'header.ph' | translate }} {{st.phoneNumberInCard}}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="edit-student-notificationForFeesForFees-open" data-toggle="modal"
      data-target="#edit-student-notificationForFeesForFees"></div>
    <div id="edit-student-notificationForFeesForFees" class="hide" role="dialog">
      <div class="modal-dialog" style="z-index: 10000;">
        <div class="modal-content" style="height: 20em;">
          <div class="modal-body">
            <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-check-square-o"
                style="color:var(--secondary-btn-bg-color);"></i> {{ 'header.updateStudentDetail' | translate }}</h3>
            <br>
            <div class="col-md-12 text-center" style="border-style: ridge;">
              <div style="text-align: left;">{{ 'header.moving' | translate }} <b>{{editStudentFormData.student.studentName}}</b> {{ 'header.from' | translate }}
                <b>{{updateStudentClassChangeError.oldClassName}}</b> {{ 'header.to' | translate }}
                <b>{{updateStudentClassChangeError.newClassName}}</b> {{ 'header.notAllowed' | translate }}
              </div>
              <div style="text-align: left;"><b>{{ 'header.reason' | translate }} </b>
                <div>&nbsp;&nbsp;&nbsp;1. <b>{{updateStudentClassChangeError.oldClassName}}</b>'{{ 'header.s' | translate }}
                  <b>{{updateStudentClassChangeError.structureName}}</b> {{ 'header.and' | translate }}
                  <b>{{updateStudentClassChangeError.newClassName}}</b>'{{ 'header.s' | translate }}
                  <b>{{updateStudentClassChangeError.structureName}}</b> {{ 'header.feesAreNotMatching' | translate }}
                </div>
                <div>&nbsp;&nbsp;&nbsp;2. <b>{{editStudentFormData.student.studentName}}</b> {{ 'header.alreadyPaid' | translate }}
                  {{currType}}.<b>{{updateStudentClassChangeError.paidAmount}}</b></div>
              </div>
              <div style="text-align: left;">{{ 'header.ifYouStillWantMove' | translate }} <b>{{editStudentFormData.student.studentName}}</b>
                {{ 'header.to' | translate }} <b>{{updateStudentClassChangeError.newClassName}}</b>,&nbsp; {{ 'header.pleaseCanceldeleteHisFeeFromFee' | translate }}
                {{ 'header.collectionAndThenChangeTheClass' | translate }}</div>
            </div>
            <div class="col-md-12 text-center" style="padding:10px 0px;">
              <button class="btn btn-info btn-sm" (click)="closeFeesNotification()">{{ 'header.close' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end of Fees Notification-->
    <!--EDIT STUDENT END-->


    <!-- Collect the nav links, forms, and other content for toggling -->
    <div class="headerbar-right hv2-headerbar-right">
      <ul class="header-nav header-nav-options hv2-header-nav-options">
        <li *ngIf="loginMode == 'WEB_ADMIN' && permissions.TAKE_ADMISSIONS == 'ENABLED'" class="">
          <!--<a [routerLink]="['/admission']" style="cursor:pointer;border-radius: 30px;padding: 5px 30px;background: #f44336;color: white;">New Admission</a>-->
          <button (click)="callImageUploadTxt()" class="btn btn-default-bright btn-raised hv2-new-admission-btn" data-toggle="modal"
            data-target="#newadmission-v2">
            <i class="ph ph-bold ph-plus"></i>
            <span class="hv2-new-admission-btn-text">{{ 'header.new' | translate }}
            {{ 'header.admission' | translate }}</span></button>
        </li>
        <li>
          <!-- Search form -->
          <form class="navbar-search hide" role="search">
            <div class="form-group">
              <input type="text" class="form-control" name="headerSearch" [placeholder]="'enterYourKeyword' | translate">
            </div>
            <button type="submit" class="btn btn-icon-toggle ink-reaction"><i class="fa fa-search"></i></button>
          </form>
        </li>
        <li class="dropdown hidden-xs hide">
          <a href="javascript:void(0);" class="btn btn-icon-toggle btn-default hv2-bell-btn" data-toggle="dropdown">
            <i class="ph ph-fill ph-bell"></i><sup class="badge style-danger hv2-bell-dot"></sup>
          </a>
          <!--<ul class="dropdown-menu animation-expand">
            <li class="dropdown-header">Today's messages</li>
            <li>
              <a class="alert alert-callout alert-warning" href="javascript:void(0);">
                <img class="pull-right img-circle dropdown-avatar" src="assets/img/avatar2.jpg?1404026449" alt="" />
                <strong>Alex Anistor</strong><br/>
                <small>Testing functionality...</small>
              </a>
            </li>
            <li>
              <a class="alert alert-callout alert-info" href="javascript:void(0);">
                <img class="pull-right img-circle dropdown-avatar" src="assets/img/avatar3.jpg?1404026799" alt="" />
                <strong>Alicia Adell</strong><br/>
                <small>Reviewing last changes...</small>
              </a>
            </li>
            <li class="dropdown-header">Options</li>
            <li><a href="">View all messages <span class="pull-right"><i class="fa fa-arrow-right"></i></span></a></li>
            <li><a href="">Mark as read <span class="pull-right"><i class="fa fa-arrow-right"></i></span></a></li>
          </ul>--><!--end .dropdown-menu -->
        </li><!--end .dropdown -->
      </ul><!--end .header-nav-options -->
      <div class="headerbar-right-lang hv2-headerbar-right-lang">
        <app-language-dropdown></app-language-dropdown>

      <ul class="header-nav header-nav-profile hv2-header-nav-profile">
        <li class="dropdown">
          <a href="javascript:void(0);" class="dropdown-toggle ink-reaction hv2-profile-toggle" data-toggle="dropdown">
            <img *ngIf="getSchoolImage" src="{{getSchoolImage}}" alt="" class="hv2-profile-avatar" />
            <span *ngIf="!getSchoolImage" class="hv2-profile-avatar hv2-profile-avatar-initials">{{ (loginMode == 'WEB_ADMIN' ? getSchoolName : staffName) | slice:0:2 | uppercase }}</span>
            <span class="profile-info">
              <span class="hv2-profile-name">{{getSchoolName}}</span>
              <small><i class="ph ph-fill ph-map-pin"></i> <span class="hv2-profile-locality">{{getSchoolLocality}}, {{getSchoolState}}</span></small>
            </span>
            <i class="ph ph-caret-down hv2-profile-caret"></i>
          </a>
          <ul class="dropdown-menu animation-dock">
            <li class="dropdown-header">{{ 'header.signedInAs' | translate }} <b>{{loginMode == 'WEB_ADMIN' ? getSchoolName : staffName}}</b></li>
            <li *ngIf="loginMode == 'WEB_ADMIN'  && permissions.SETTINGS_MANAGEMENT == 'ENABLED'"><a
              style="cursor: pointer" [routerLink]="['/settings']">{{ 'header.profile' | translate }}</a></li>
              <!-- <li><a href="">My blog <span class="badge style-danger pull-right">16</span></a></li> -->
              <li class="hide"><a style="cursor: pointer" [routerLink]="['/broadcast']">{{ 'header.viewNotifications' | translate }}</a></li>
              <li class="divider"></li>
              <!-- <li><a href=""><i class="fa fa-fw fa-lock"></i> Lock</a></li> -->
              <!-- <li><a href="index.php"><i class="fa fa-fw fa-lock"></i> Lock</a></li> -->
              <li><a (click)="logout()" style="cursor: pointer"><i class="fa fa-fw fa-power-off text-danger"></i>
                {{ 'header.logout' | translate }}</a></li>
              </ul><!--end .dropdown-menu -->
            </li><!--end .dropdown -->
          </ul><!--end .header-nav-profile -->
        </div>
      <ul class="header-nav header-nav-toggle hide">
        <li>
          <!--<a class="btn btn-icon-toggle btn-default" href="#offcanvas-search" data-toggle="offcanvas" data-backdrop="false">
            <i class="fa fa-ellipsis-v"></i>-->
          <a class="btn btn-icon-toggle btn-default">
            <i class="fa fa-ellipsis-v"></i>
          </a>
        </li>
      </ul><!--end .header-nav-toggle -->
    </div><!--end #header-navbar-collapse -->
  </div>
  <div class="modal fade" id="modalTc" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" id="modalTcInside" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 *ngIf="isTcGenerationConfirm" class="modal-title" id="exampleModalLabel">{{'tcGenerationUnderProcess' | translate}}</h5>
          <h5 *ngIf="!isTcGenerationConfirm" class="modal-title" id="exampleModalLabel">{{'messageForTc' | translate}}</h5>
        </div>
        <div *ngIf="tcGeneratedJob && isTcGenerationConfirm" >
          <div class="message-status-tc">
            {{'generatingMessage' | translate}}
          </div>
          <span class="created-job-id">{{'jobId' | translate}} : # {{tcJobId}}</span>
        </div>
        <div  *ngIf="!tcGeneratedJob && isTcGenerationConfirm" class="tc-loader">
          <div class="spinner"></div>
        </div>
     
        <div class="modal-footer" *ngIf="isTcGenerationConfirm">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">{{'close' | translate}}</button>
          <button (click)="openTC()" type="button"  class="btn btn-primary">{{'openTC' | translate}}</button>
        </div>

        <div class="modal-footer" *ngIf="!isTcGenerationConfirm">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">{{'no' | translate}}</button>
          <button (click)="generateTcSelectedStudent()" type="button"  class="btn btn-primary">{{'yes' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="idCard" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" id="modalIdInside" role="document">
      <div  class="id-card-selection">
        <div  class="heading-id-card-selection">
         <span *ngIf="!isIdCardGenerated">{{ 'header.pleaseSelectIdCardTemplate' | translate }}</span>
         <span *ngIf="isIdCardGenerated">{{ 'header.congratulations' | translate }} !!</span>
        </div>

          <div *ngIf="!isIdCardGenerated && !isFetchingIdCard" class="id-image">
            <div *ngFor="let id of idCardTemplates" (click)="selectIdCard(id.templateId)" class="id-card-image">
              <div class="selection-container">
                <div *ngIf="!id.isSelected" class="selection-icon">
                </div>
                <div *ngIf="id.isSelected" class="selected-id-card">
                  <i class="ri-check-line"></i>
                </div>
              </div>
              <img  [src]="id.defaultTemplateImageUrl" alt="">
            </div>
          </div>

          <app-new-loader *ngIf="isFetchingIdCard">

          </app-new-loader>

          <div *ngIf="isIdCardGenerated" class="success-image">
            <div class="success-container">
              <i class="ri-check-line"></i>
            </div>
            <div class="message-for-id">
              {{ 'header.yourIdCardGenerationHasBeenScheduledYouCanCheckByClickingOnTheViewIdsButton' | translate }}
            </div>
          </div>

          <div *ngIf="!isIdCardGenerated" class="button-for-id-card">
            <div class="cancel-id-card">
              <button (click)="closeIdCard()">{{ 'header.cancel' | translate }}</button>
            </div>
            <div class="generate-id-card">
              <button (click)="generateIdCard()">
                <span *ngIf="!isGeneratingId">{{ 'header.generate' | translate }}</span>
                <span *ngIf="isGeneratingId"><app-button-loader></app-button-loader></span>
              </button>
            </div>
          </div>

          <div  *ngIf="isIdCardGenerated" class="button-for-id-card">
            <div class="cancel-id-card">
              <button (click)="closeIdCard()">{{ 'header.cancel' | translate }}</button>
            </div>
            <div class="generate-id-card">
              <button (click)="navigateToIdCardPage()">{{ 'header.viewIds' | translate }}</button>
            </div>
          </div>


       <div >

       </div>
      </div>
    </div>
  </div>

   <div class="modal fade" id="idCardStaff" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" id="modalIdInside" role="document">
      <div  class="id-card-selection">
        <div  class="heading-id-card-selection">
         <span *ngIf="!isStaffIdCardGenerated">{{ 'header.pleaseSelectIdCardTemplate' | translate }}</span>
         <span *ngIf="isStaffIdCardGenerated">{{ 'header.congratulations' | translate }} !!</span>
        </div>

          <div *ngIf="!isStaffIdCardGenerated && !staffIsFetchingIdCard" class="id-image">
            <div *ngFor="let id of staffIdCardTemplates" (click)="selectedStaffIdCard(id.templateId)" class="id-card-image">
              <div class="selection-container">
                <div *ngIf="!id.isSelected" class="selection-icon">
                </div>
                <div *ngIf="id.isSelected" class="selected-id-card">
                  <i class="ri-check-line"></i>
                </div>
              </div>
              <img  [src]="id.defaultTemplateImageUrl" alt="">
            </div>
          </div>

          <app-new-loader *ngIf="staffIsFetchingIdCard">

          </app-new-loader>

          <div *ngIf="isStaffIdCardGenerated" class="success-image">
            <div class="success-container">
              <i class="ri-check-line"></i>
            </div>
            <div class="message-for-id">
              {{ 'header.yourIdCardGenerationHasBeenScheduledYouCanCheckByClickingOnTheViewIdsButton' | translate }}
            </div>
          </div>

          <div *ngIf="!isStaffIdCardGenerated" class="button-for-id-card">
            <div class="cancel-id-card">
              <button (click)="closeStaffIdCard()">{{ 'header.cancel' | translate }}</button>
            </div>
            <div class="generate-id-card">
              <button (click)="generateStaffIdCard()">
                <span *ngIf="!isStaffGeneratingId">{{ 'header.generate' | translate }}</span>
                <span *ngIf="isStaffGeneratingId"><app-button-loader></app-button-loader></span>
              </button>
            </div>
          </div>

          <div  *ngIf="isStaffIdCardGenerated" class="button-for-id-card">
            <div class="cancel-id-card">
              <button (click)="closeStaffIdCard()">{{ 'header.cancel' | translate }}</button>
            </div>
            <div class="generate-id-card">
              <button (click)="navigateToStaffIdCardPage()">{{ 'header.viewIds' | translate }}</button>
            </div>
          </div>


       <div >

       </div>
      </div>
    </div>
  </div>


</header>

<!-- New admission form (delegated to app-admission-v2). Rendered as a
     sibling of <header>, not a descendant: #header is `position: absolute`
     with a capped `z-index: 1 !important` (styles.css), which creates a
     stacking context that would otherwise trap this modal below any
     page-level element with z-index >= 2, no matter what z-index the
     modal itself declares. -->
<app-admission-v2></app-admission-v2>


<!-- END HEADER-->
